<div class="page" style="height: 100vh;">
    <div class="container pt-70">
        <div class="row justify-content-center">
            <div class="col-lg-6 col-md-12 col-12">
                <div class="center-block">
                    <div class="login-box">
                        <div class="icon-box">
                            <img src="assets/images/cap.png" class="img-fluid i_img">
                        </div>
                        <!-- <img src="{{headerimage}}" class="img-fluid d-block mx-auto mt-35" style="width: 500px;"> -->
                        <!-- <h5 class="mt-35" style="color: red;">Please refresh the page before change password</h5> -->
                        <h4>Change Password</h4>
                        <form #changePasswordForm="ngForm" (ngSubmit)="onSubmit()">
                            <div class="form-group">
                                <label>Old password</label><span class="text-danger">*</span>
                                <input type="password" #oldPassword="ngModel" ngModel name="oldPassword"
                                    class="form-control" placeholder="Enter old password" required>
                                <span *ngIf="changePasswordForm.submitted && oldPassword.invalid">
                                    <p *ngIf="oldPassword.errors.required" class="error_message" style="color: red;">
                                        Old password is required
                                    </p>
                                </span>
                            </div>
                            <div class="form-group">
                                <label>New password</label><span class="text-danger">*</span>
                                <input type="password" #newPassword="ngModel" ngModel name="newPassword"
                                    class="form-control" placeholder="Enter new password" minlength="8" required>
                                <span style="color: grey; font-weight: bold;">(Password must be atleast of 8
                                    character)</span>
                                <span *ngIf="changePasswordForm.submitted && newPassword.invalid">
                                    <p *ngIf="newPassword.errors.required" class="error_message" style="color: red;">
                                        New password is required
                                    </p>
                                    <p *ngIf="newPassword.errors.minlength" class="error_message" style="color: red;">
                                        New password must be atleast of 8 character
                                    </p>
                                </span>
                            </div>
                            <div class="form-group">
                                <label>Confirm password</label><span class="text-danger">*</span>
                                <input type="password" #confirmPassword="ngModel" ngModel name="confirmPassword"
                                    class="form-control" placeholder="Enter confirm password"
                                    appConfirmEqualValidator="newPassword" id="confirmPassword" required>
                                <span style="color: grey; font-weight: bold;">(Password must be atleast of 8
                                    character)</span>
                                <span *ngIf="changePasswordForm.submitted && confirmPassword.invalid">
                                    <p *ngIf="confirmPassword.errors.required" class="error_message"
                                        style="color: red;">
                                        Confirm password is required
                                    </p>
                                    <span class="help-block error_message" style="color: red;"
                                        *ngIf="confirmPassword.touched && confirmPassword.errors?.notEqual && !confirmPassword.errors?.required">
                                        Password and confirm password does not match
                                    </span>
                                </span>
                            </div>
                            <button type="submit" class="btn btn-primary btn-block mt-3">Change password</button>
                        </form>
                        <ngx-spinner bdcolor="rgba(51, 51, 51, 0.8)" size="default" type="ball-spin-clockwise">
                            <p style="color: white;">Please Wait.</p>
                        </ngx-spinner>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<script type="text/javascript">
    $(document).ready(function () {

        $('[data-toggle="popover"]').popover()
    });
</script>